import {AccountTypeCodes, UserTypes} from '../constants/ApplicationConstants';
import IDVerificationConstants from '../constants/IDVerificationConstants';
import Validators from './Validators.js';
import Products from './Products.js';
import _ from 'lodash';

class DigitalConsentEligibilityHelperClass {
    checkProductEligibility(productId) {
        if (Products.isAnnuity(productId)) {
            return false;
        }
        return true;
    }

    checkAccountTypeEligibility(accountType) {
        if (accountType === AccountTypeCodes.INDIVIDUAL ||
            accountType === AccountTypeCodes.SOLE_TRADER ||
            accountType === AccountTypeCodes.JOINT) {
            return true;
        }
        return false;
    }

    checkUserTypeEligibility(userType) {
        return userType === UserTypes.ADVISER;
    }

    checkUserStatusEligibility(oin) {
        return Validators.requiredValidation(oin) && oin > 0;
    }

    checkMobileNumberEligibility(val) {
        return Validators.requiredValidation(val) && Validators.isPhoneNumber(val) && Validators.isMobileNumber(val);
    }

    checkJointMobileNumberEligibility(investorList) {
        let validMobileNumbers = [];
        for (var i = 0; i < investorList.length; i++) {
            if (this.checkMobileNumberEligibility(investorList[i].contactDetails.mobile)) {
                validMobileNumbers.push(investorList[i]);
            }
        }
        return validMobileNumbers.length === investorList.length;
    }

    checkJointMobileNumberUniqueness(investorList) {
        let mobileNumbers = [];
        _.forEach(investorList, function(n) {
            mobileNumbers.push(n.contactDetails.mobile);
        });

        let uniqueMobileNumbers = _.unique(mobileNumbers);
        return uniqueMobileNumbers.length === investorList.length;
    }

    checkJointKycStatusEligibility(investorList) {
        let kycDone = _.where(investorList, { kycFlag: true });
        return kycDone.length === investorList.length;
    }

    checkJointUserStatusEligibility(investorList) {
        let existingUsers = [];
        for (let i = 0; i < investorList.length; i++) {
            if (this.checkUserStatusEligibility(investorList[i].oin)) {
                existingUsers.push(investorList[i]);
            }
        }
        return existingUsers.length === investorList.length;
    }

    IndividualKycCheck(kycFlag, productId) {
        if(Products.isSuper(productId)) {
            return true;
        }else {
            return kycFlag;
        }
    }

    jointEligibilityCheck(request) {
        if (this.checkJointMobileNumberEligibility(request.investorList) &&
            this.checkJointMobileNumberUniqueness(request.investorList)) {
            if(this.checkUserTypeEligibility(request.userType)) {
                if(this.checkJointKycStatusEligibility(request.investorList) && request.verificationResult) {
                    return {
                        eligible: IDVerificationConstants.Eligibility.Eligible,
                        checkComplete:true
                    }
                }
                else {
                    return {
                        eligible: IDVerificationConstants.Eligibility.NotEligible,
                        checkComplete:true
                    }  
                }
            }
            else if (this.checkJointUserStatusEligibility(request.investorList) && this.checkJointKycStatusEligibility(request.investorList)) {
                return {
                    eligible: IDVerificationConstants.Eligibility.NotRequired,
                    checkComplete:true
                }
            }
            else {
                return {
                    eligible: IDVerificationConstants.Eligibility.NotEligible,
                    checkComplete:true
                }  
            }

        } else {
            return {
                eligible: IDVerificationConstants.Eligibility.NotEligible,
                checkComplete:true
            }
        }
    }

    individualEligibilityCheck(request) {
        if (this.checkUserTypeEligibility(request.userType)){
            if (this.checkMobileNumberEligibility(request.mobileNumber) &&
                this.IndividualKycCheck(request.kycFlag, request.productId) && request.verificationResult) {
                return {
                    eligible: IDVerificationConstants.Eligibility.Eligible,
                    checkComplete: true
                }
            } else {
                return {
                    eligible: IDVerificationConstants.Eligibility.NotEligible,
                    checkComplete:true
                }
            }
            
        } else if (this.checkUserStatusEligibility(request.oin) && request.kycFlag) {
            return {
                eligible: IDVerificationConstants.Eligibility.NotRequired,
                checkComplete:true
            }
        } else {
            return {
                eligible: IDVerificationConstants.Eligibility.NotEligible,
                checkComplete:true
            }
        }
    }

    generateVerifyMobileNumberRequest(yourDetailsSection, accountType) {
        var requests = [];
        if (yourDetailsSection) {
            if (accountType === AccountTypeCodes.INDIVIDUAL || accountType === AccountTypeCodes.SOLE_TRADER) {
                requests.push({
                    firstName: yourDetailsSection.givenName,
                    lastName: yourDetailsSection.lastName,
                    mobileNumber: yourDetailsSection.contactDetails.mobile,
                    dateOfBirth: yourDetailsSection.dateOfBirth
                });
            } else if(accountType === AccountTypeCodes.JOINT && yourDetailsSection.investorList != null && yourDetailsSection.investorList.length > 0) {
                for (var i = 0; i < yourDetailsSection.investorList.length; i++) {
                    var inv = yourDetailsSection.investorList[i];
                    requests.push({
                        firstName: inv.givenName,
                        lastName: inv.lastName,
                        mobileNumber: inv.contactDetails.mobile,
                        dateOfBirth: inv.dateOfBirth
                    });
                }
            }
            
        }
        return { mobileNumberInfos: requests };
        
    }
}

// singleton
const DigitalConsentEligibilityHelper = new DigitalConsentEligibilityHelperClass();

export default DigitalConsentEligibilityHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/DigitalConsentEligibilityHelper.js